var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReturnOrderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_51",
    x: 0,
    y: 0,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3134",
    "data-name": "Rectangle 3134",
    width: 37.26,
    height: 31.836,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9345",
    "data-name": "Group 9345",
    transform: "translate(8.991 6.459)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.99, -6.46)",
    filter: "url(#Ellipse_51)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51-2",
    "data-name": "Ellipse 51",
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11232",
    "data-name": "Group 11232",
    transform: "translate(25.009 27.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9242",
    "data-name": "Group 9242",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M32.034,24.226A4.49,4.49,0,0,1,33.11,27.46a4.844,4.844,0,0,1-1.228,2.9,4.637,4.637,0,0,1-5.16,1.11,4.684,4.684,0,0,1-2.836-3.836,4.527,4.527,0,0,1,.407-2.448H20.729a5.073,5.073,0,0,1,.426,1.427,4.374,4.374,0,0,1-.577,2.845,4.895,4.895,0,0,1-.9,1.181,3.872,3.872,0,0,1-1.242.809,4.565,4.565,0,0,1-5.183-1.039,4.512,4.512,0,0,1-1.32-3.066,4.332,4.332,0,0,1,1.089-3.134c-.139-.1-.26-.193-.382-.282A6.5,6.5,0,0,1,9.972,19.7q-.17-.935-.314-1.875c-.161-1.042-.311-2.086-.471-3.128-.144-.939-.3-1.877-.444-2.816-.091-.586-.165-1.174-.262-1.758-.2-1.209-.332-2.431-.62-3.625-.208-.863-.429-1.724-.651-2.584a2.547,2.547,0,0,0-.2-.563,1.342,1.342,0,0,0-1.188-.7c-.083-.005-.166,0-.248,0-1.353,0-2.706,0-4.059,0a2.052,2.052,0,0,1-.472-.048A1.32,1.32,0,0,1,0,1.213,1.214,1.214,0,0,1,1.071.047,3.544,3.544,0,0,1,1.606,0Q3.7,0,5.789,0A3.927,3.927,0,0,1,7.631.4,4.021,4.021,0,0,1,9.754,3.111q.258,1.022.51,2.045a.167.167,0,0,0,.19.147c.062,0,.124,0,.186,0q5.187,0,10.375,0a2.136,2.136,0,0,1,.63.093,1.217,1.217,0,0,1,.861,1.043,1.237,1.237,0,0,1-.539,1.223,1.482,1.482,0,0,1-.83.281c-.069,0-.138,0-.207,0H11.095c-.087,0-.174.007-.288.012.029.185.053.346.078.506q.163,1.031.326,2.062c.136.865.273,1.729.4,2.594s.256,1.732.389,2.6q.213,1.39.435,2.778a8.064,8.064,0,0,0,.207,1.1,3.955,3.955,0,0,0,2.908,2.81,4.478,4.478,0,0,0,1.17.127q5.85.007,11.7,0a4.037,4.037,0,0,0,2.967-1.2A3.959,3.959,0,0,0,32.5,19.106c.147-.919.282-1.839.423-2.759.038-.245.074-.491.121-.734a1.322,1.322,0,0,1,2.614.379c-.073.636-.182,1.268-.277,1.9-.076.511-.149,1.023-.234,1.532a7.325,7.325,0,0,1-1.133,2.9A6.535,6.535,0,0,1,32.332,24c-.064.041-.125.086-.185.132-.033.025-.062.054-.113.1m-1.57,2.965a1.978,1.978,0,0,0-3.954-.078,1.977,1.977,0,1,0,3.954.078M16.559,25.209A1.965,1.965,0,1,0,18.527,27.2a1.955,1.955,0,0,0-1.968-1.993",
    transform: "translate(0 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M138.277,87.84h-9.621a1,1,0,1,1,0-2.006h9.621a1,1,0,1,1,0,2.006",
    transform: "translate(-102.02 -80.2)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M113.3,63.027a1,1,0,0,1-.536-1.851l4.471-2.822a1,1,0,0,1,1.071,1.7l-4.471,2.822a1,1,0,0,1-.534.155",
    transform: "translate(-88.233 -55.386)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M117.77,90.465a1,1,0,0,1-.534-.155l-4.471-2.822a1,1,0,0,1,1.071-1.7l4.471,2.822a1,1,0,0,1-.536,1.851",
    transform: "translate(-88.232 -80.023)",
    fill: "#0094d1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnOrderIcon);
export default __webpack_public_path__ + "static/media/return-order-icon.574ed9504fecea402e6676ad7925b530.svg";
export { ForwardRef as ReactComponent };